import React, { useState } from "react";
import { Avatar } from "antd";
import { PaperClipOutlined } from "@ant-design/icons";
import { httpService } from "../../base/services/httpService.service";
import { Constants } from "../../utils/constants";

import "./Tickets.scss";

const ChatCard = React.memo(({ organizationName, createdAt, message, attachments }) => {
   const [loadingPreview, setLoadingPreview] = useState(false);

   const previewFile = (filePath) => {
      setLoadingPreview(true);
      let correctedFilePath = filePath.replace(/\\202/g, "\\x82");
      const payload = [
         {
            fileKey: correctedFilePath
         }
      ];

      const params = new URLSearchParams({ platformId: Constants.PLATFORM_ID });
      httpService
         .post(
            `/FileData/getFileUrlByFileKeyAndEntityId?${params.toString()}`,
            payload,
            (response) => {
               setLoadingPreview(false);
               if (response && response.data && response.data && response.data[0].fileUrl) {
                  window.open(response.data[0].fileUrl, "_blank");
               } else {
                  console.error("Something went wrong", response);
               }
            }
         )
         .catch(() => {
            setLoadingPreview(false);
         });
   };

   return (
      <div className="chat-card">
         <div className="chat-card__header">
            <Avatar style={{ backgroundColor: "#EEF2FF", color: "#5770CB" }} size={36}>
               {organizationName?.[0].toUpperCase()}
            </Avatar>
            <p>{organizationName}</p>
         </div>
         <div className="chat-card__messages">
            <div
               style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  justifyContent: "flex-end"
               }}
            >
               <Avatar
                  style={{
                     backgroundColor: "#FFF1E8",
                     color: "#F58F45"
                  }}
               >
                  {organizationName?.[0].toUpperCase()}
               </Avatar>
               <p
                  style={{
                     color: "#555555",
                     fontWeight: 500,
                     fontFamily: "poppins",
                     fontSize: "14px",
                     margin: 0
                  }}
               >
                  {organizationName}
                  <span style={{ color: "#979797", fontWeight: 400, fontSize: "12px" }}>
                     {" "}
                     {createdAt}
                  </span>
               </p>
            </div>
            <div key={message} className="chat-card__message">
               <span>{message}</span>
               <div>
                  <p style={{ color: "#3A3737", fontSize: "16px" }}>{message?.message}</p>
                  <div className="inner-card d-flex align-items-center justify-content-between">
                     <div
                        className="inner-content"
                        style={{
                           width: "100%",
                           display: "flex",
                           flexDirection: "column",
                           gap: "5px"
                        }}
                     >
                        {attachments && (
                           <div className="chat-card__attachments">
                              {attachments.map((file, index) => {
                                 const fileName = file.split("/").pop();
                                 return (
                                    <div
                                       key={index}
                                       className="chat-card__attachment"
                                       onClick={() => previewFile(file)}
                                       style={{
                                          cursor: loadingPreview ? "wait" : "pointer"
                                       }}
                                    >
                                       <div className="chat-card__attachment-icon">
                                          <PaperClipOutlined />
                                       </div>
                                       <div className="chat-card__attachment-info">
                                          <p className="chat-card__attachment-name">{fileName}</p>
                                       </div>
                                    </div>
                                 );
                              })}
                              {/* {data.attachments?.length > 1 && (
                                 <div className="chat-card__attachments-footer chat-card__download-all">
                                    <DownloadOutlined /> Download all files
                                 </div>
                              )} */}
                           </div>
                        )}
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
});

export default ChatCard;
